import { all, takeEvery, fork, put, select, call } from 'redux-saga/effects'
import actions from './actions'

// api
import {
    getListUsers,
    getUserByArray,
    getListUserNotCheck,
} from '../../services/apis/UserAPIServices'
import {
    sendMessage,
    getListMessage,
    replyMessage,
    getListReply,
    getListReplyInReply,
    sendReplyInReply
} from '../../services/apis/messageAPIservice'
import { getListOrgAPI } from '../../services/apis/OrganizationsAPIService'
import { notification } from 'antd'

function* saga_getlistMessage(action) {
    try {
        let user_info = yield select(state => state.auth.userInfo)
        const { uid, status, page_number, text, isloadmore } = action.payload
        let request
        if (text) {
            request = yield call(getListMessage, uid, status, page_number, text)
        } else {
            request = yield call(getListMessage, uid, status, page_number, '')
        }
        console.log('get list message', request)
        if (request.error.code === 200) {
            yield put(actions.action.getListmessageDone(request, isloadmore))
            yield put(actions.action.updateIsloadingMess(false))
            let lstuid = []
            request.data.map(vl => {
                if (vl.owner_id === user_info.uid) {
                    lstuid = lstuid.concat(vl.receiver_uid)
                } else {
                    lstuid = lstuid.concat(vl.owner_id)
                }
            })

            const requestUser = yield call(getUserByArray, lstuid)

            if (requestUser.error.code === 200) {
                yield put(actions.action.updateCurrentUser(requestUser.data))
            }
        } else {
            yield put(actions.action.updateIsloadingMess(false))
        }
    } catch (ex) {
        console.error('get list message error', ex.message)
    }
}

function* saga_getListReply(action) {
    try {
        const { messid } = action.payload
        const request = yield call(getListReply, messid)
        if (request.error.code === 200) {
            yield put(actions.action.getListReplyInMessDone(request.data))
        } else {
            yield put(actions.action.getListReplyInMessDone([]))
        }
    } catch (ex) {
        console.error('get list reply message error', ex.message)
    }
}
function* saga_getListOrg() {
    try {
        const request = yield call(getListOrgAPI, 0)
        if (request.error.code === 200) {
            yield put(actions.action.getCurrentListOrgDone(request.data))
        } else {
            yield put(actions.action.getCurrentListOrgDone([]))
        }
    } catch (ex) {
        console.error('get list ORG message error', ex.message)
    }
}

function* saga_sendMessage(action) {
    try {
        const { body, receiver_oid, receiver_uid } = action.payload
        const request = yield call(sendMessage, receiver_uid, receiver_oid, body)
        if (request.error.code === 200) {
            notification.success({ message: 'Gửi báo cáo thành công' })
        }
    } catch (ex) {
        console.error('send message error', ex.message)
    }
}
function* saga_replyMessage(action) {
    try {
        const { body } = action.payload
        const request = yield call(replyMessage, body)
        if (request.error.code === 200) {
            notification.success({ message: 'Gửi tin nhắn trả lời thành công' })
            yield put(actions.action.getListReplyInMess(body.messid))
        }
    } catch (ex) {
        console.error('send message error', ex.message)
    }
}
function* saga_getListUserByText(action) {
    try {
        const { text } = action.payload
        const request = yield call(getListUserNotCheck, 1, 100, 1, text)
        console.log('request', request)
        if (request.error.code === 200) {
            yield put(actions.action.getListuserByTextDone(request.data))
        } else {
            yield put(actions.action.getListuserByTextDone([]))
        }
    } catch (ex) {
        console.error('Change page object size error : ', ex.message)
    }
}
function* saga_getReceiverInfo(action) {
    try {
        const { uid } = action.payload
        const request = yield call(getUserByArray, uid)
        console.log('request', request)
        if (request.error.code === 200) {
            yield put(actions.action.getInfoUidReceiverDone(request.data))
        } else {
            yield put(actions.action.getInfoUidReceiverDone([]))
        }
    } catch (ex) {
        console.error('Change page object size error : ', ex.message)
    }
}
function* saga_getReplyInReply(action) {
    try {
        const { reply_id } = action.payload
        const request = yield call(getListReplyInReply, reply_id)
        console.log('request data reply', request)
        if (request.error.code === 200) {
            yield put(actions.action.getReplyInReplyDone(request.data, reply_id))
        }
    } catch (ex) {
        console.error('get list reply in reply error : ', ex.message)
    }
}
function* saga_sendReplyInReply(action) {
    try {
        const { body } = action.payload
        const request = yield call(sendReplyInReply, body)
        console.log('request', request)
        if (request.error.code === 200) {
            yield put(actions.action.getReplyInReply(body.reply_id))
        }
    } catch (ex) {
        console.error('send reply in reply error : ', ex.message)
    }
}

function* listen() {
    yield takeEvery(actions.type.GET_LIST_USER_BY_TEXT, saga_getListUserByText)
    yield takeEvery(actions.type.SEND_MESSAGE, saga_sendMessage)
    yield takeEvery(actions.type.GET_LIST_MESSAGE, saga_getlistMessage)
    yield takeEvery(actions.type.REPLY_MESSAGE, saga_replyMessage)
    yield takeEvery(actions.type.GET_LIST_REPLY_IN_MESSAGE, saga_getListReply)
    yield takeEvery(actions.type.GET_INFO_UID_RECEIVER, saga_getReceiverInfo)
    yield takeEvery(actions.type.GET_CURRENT_LIST_ORG, saga_getListOrg)
    yield takeEvery(actions.type.GET_REPLY_IN_REPLY, saga_getReplyInReply)
    yield takeEvery(actions.type.SEND_REPLY_IN_REPLY, saga_sendReplyInReply)




}

export default function* quickMessageSaga() {
    yield all([fork(listen)])
}
